module.exports = __webpack_public_path__ + "black_shipzone.png?10f3eeb1b3d823b6732ba5eca3c8cb6c";


//////////////////
// WEBPACK FOOTER
// ./assets/images/black_shipzone.png
// module id = 12
// module chunks = 0